<template>
    <div class="space-y-10">
        <slot />
    </div>
</template>
